import TemplateView from '../../TemplateView'
import Button from '../../components/Button'
import messageResource from '../../messageResource'

export default class MobileAppButtons extends TemplateView {
    constructor({
        onIosButtonClick = () => {},
        onAndroidButtonClick = () => {},
    }) {
        super()

        this.callbacks = {
            onIosButtonClick,
            onAndroidButtonClick,
        }
    }

    templateHtml() {
        return `<div class='mobileAppButtons'/>`
    }

    afterRender() {
        new Button({
            additionalClass: 'iosButton',
            label: messageResource.getMessage('menu.addons.item.mobile.button.ios'),
            onClickCb: this.callbacks.onIosButtonClick,
        }).init(this.getEl())
        new Button({
            additionalClass: 'androidButton',
            label: messageResource.getMessage('menu.addons.item.mobile.button.android'),
            onClickCb: this.callbacks.onAndroidButtonClick,
        }).init(this.getEl())
    }
}


// WEBPACK FOOTER //
// ./web/js/support/addons/MobileAppButtons.js